module.exports = __webpack_public_path__ + "6ac9b8bd15d2451c5288c737530cb0d7.pdf";